import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import APP_SETTINGS from "../../config/settings";
import customerClaimEndpoints, {type as customerType} from "./customerClaimEndpoints";

export const api = createApi({
  reducerPath: 'customerClaimsApi',
  baseQuery: fetchBaseQuery({baseUrl: APP_SETTINGS.API_ENDPOINT}),
  tagTypes: [customerType],
  keepUnusedDataFor: 100,
  refetchOnMountOrArgChange: 100,
  endpoints: (builder) => ({
    ...customerClaimEndpoints(builder),
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDuplicatedClaimQuery,

  endpoints
} = api;

export default api;
